import { ValidatorFn, FormGroup } from "@angular/forms";
import { _i18n_str } from "../../assets/i18n/non-static-ids";

export function manualItemTypeValidator(): ValidatorFn {
  return (group: FormGroup): { [key: string]: any } | null => {
    let returnValue: {
      valid: boolean;
      error: string;
      errorI18n: string;
    } = null;
    const itemType = group.value.itemType;
    switch (itemType) {
      case "CONSULTATION_TOPIC": {
        const requiredValue = group.value.consultationTopicId;
        if (requiredValue === null) {
          returnValue = {
            valid: false,
            error:
              "Consultation topic is required if item type is 'Consultation topic'",
            errorI18n: _i18n_str(
              "MANUAL_ITEM_TYPE.VALIDATION_ERRORS.CONSULTATION_TOPIC_REQUIRED"
            )
          };
        }
        break;
      }
      case "DIAPROFIL_PRO_ITEM": {
        const requiredValue = group.value.questionnaireItemId;
        if (requiredValue === null) {
          returnValue = {
            valid: false,
            error: "PRO item is required if item type is 'PRO item'",
            errorI18n: _i18n_str(
              "MANUAL_ITEM_TYPE.VALIDATION_ERRORS.QUESTIONNAIRE_ITEM_ID_REQUIRED"
            )
          };
        }
        break;
      }
      case "SCORE": {
        const requiredValue = group.value.scoreId;
        if (requiredValue === null) {
          returnValue = {
            valid: false,
            error: "Score name is required if item type is 'Score'",
            errorI18n: _i18n_str(
              "MANUAL_ITEM_TYPE.VALIDATION_ERRORS.SCORE_ID_REQUIRED"
            )
          };
        }
        break;
      }
      case "DASHBOARD_AREA": {
        const requiredValue = group.value.dashboardAreaId;
        if (requiredValue === null) {
          returnValue = {
            valid: false,
            error:
              "Dashboard area name is required if item type is 'Dashboard area'",
            errorI18n: _i18n_str(
              "MANUAL_ITEM_TYPE.VALIDATION_ERRORS.DASHBOARD_AREA_ID_REQUIRED"
            )
          };
        }
        break;
      }
      default: {
        return returnValue;
      }
    }
    return returnValue;
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/manual-item-type-validator.directive.ts